
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "t": "1606810294348",
    "class": "icon",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "p-id": "3808",
    "width": "200",
    "height": "200"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "d": "M642.662 5.837c56.32 0 102.093 45.875 102.093 102.093v83.763h195.277a40.858 40.858 0 1 1-0.102 81.613h-38.298v571.392c0 95.539-77.824 173.465-173.466 173.465h-432.23c-95.642 0-173.466-77.824-173.466-173.568V273.408H84.173a40.858 40.858 0 1 1 0-81.715h195.174V107.93c0-56.32 45.773-102.093 102.093-102.093zM820.02 273.408H204.186v571.187c0 50.688 41.267 91.853 91.852 91.853h432.026a91.955 91.955 0 0 0 91.853-91.853V273.408z m-421.785 159.13a37.888 37.888 0 0 1 37.785 37.785v290.509a37.888 37.888 0 0 1-75.571 0V470.323a37.888 37.888 0 0 1 37.786-37.785z m227.635 0a37.888 37.888 0 0 1 37.785 37.785v290.509a37.888 37.888 0 0 1-75.57 0V470.323a37.888 37.888 0 0 1 37.785-37.785zM642.662 87.45H381.44a20.48 20.48 0 0 0-20.48 20.48v83.66h302.08v-83.763a20.48 20.48 0 0 0-20.378-20.48z",
        "p-id": "3809"
      }
    }
  ]
})
    }
  